import apiClient from '@/services/axios'

export async function post(courseId) {
    var response = await apiClient.post(`/LessonInstances/${courseId}/resetCourse`)
    if (response) {
        return response.data
    }

    throw new Error('Unable to reset course.')
}